import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { StyledTableCell } from "./styles";
import { StaffPermissionHeader } from "../../utils/headers";

interface IProps {
  allComponentsData: Array<{
    module_name: string;
    permissions: string[];
  }>;
  displayTablePermissions: (
    action: string,
    moduleName: string,
    permissions: string[]
  ) => React.ReactNode;
}

const UserPermission: React.FC<IProps> = ({
  allComponentsData,
  displayTablePermissions,
}) => {

  return (
    <TableContainer>
      <Box className="table-width">
        <Table
          sx={{
            "& .MuiTableCell-root": {
              borderLeft: "1px solid rgba(224, 224, 224, 1)", // Default left border
            },
          }}
        >
          <TableHead>
            <TableRow>
              {StaffPermissionHeader?.map((header: string, index: number) => (
                <StyledTableCell
                  key={index}
                  align={
                    header === "Actions"
                      ? "right"
                      : header === "Permissions"
                      ? "left"
                      : "center"
                  }
                  sx={{
                    borderRight:
                      header === "Permissions"
                        ? "none"
                        : "1px solid rgba(224, 224, 224, 1)",
                  }}
                >
                  {header}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {allComponentsData?.map((item, index) => (
              <TableRow key={index}>
                <StyledTableCell sx={{ fontWeight: "bold" }}>
                  {item.module_name}
                </StyledTableCell>
                {["view", "edit", "add", "delete"].map((action) => (
                  <StyledTableCell
                    key={action}
                    sx={{
                      borderRight:
                        action === "permissions"
                          ? "none"
                          : "1px solid rgba(224, 224, 224, 1)",
                    }}
                  >
                    {displayTablePermissions(
                      action,
                      item.module_name,
                      item.permissions
                    )}
                  </StyledTableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </TableContainer>
  );
};

export default UserPermission;
